import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useRecoilState, useRecoilValue } from 'recoil';
import useSWR from 'swr';
import he from 'he';

import { Filters, Worklist, Pagination } from '@components/organisms';
import { Body } from '@components/templates';
import { ADMIN_ACCESS_TOKEN_KEY } from '../../../App';
import { ProductUser } from '@models/transfer/transfer';
import { StyledFlexColumnsWrapper, StyledSearchBarWrapper } from './style';
import { TransferCheckState, userPageCurrentPageTransferState } from './atom/transfer';

const Transfer = () => {
  const navigate = useNavigate();
  const [accessToken, setAccessToken] = useState('');
  const [valueState, setValueState] = useState({
    searchKey: 'ID', // searchType
    searchKeyword: '', // searchValue
  });
  const [pageConditionsValue, setPageConditionsValue] = useRecoilState(userPageCurrentPageTransferState);
  const ischecked = useRecoilValue(TransferCheckState);
  let productUsers: ProductUser[] = [];

  useEffect(() => {
    const newToken = localStorage.getItem(ADMIN_ACCESS_TOKEN_KEY);
    if (newToken && accessToken !== newToken) {
      setAccessToken(newToken);
    }
  }, []);

  const url = `api/transfer?countPerPage=20&currentPage=${pageConditionsValue.currentPage}&exist=${ischecked.ischecked}&searchType=${valueState.searchKey}&searchValue=${valueState.searchKeyword}`;
  const { data } = useSWR(!!accessToken.length ? [{ url, accessToken }] : null);

  if (data) {
    if (data.code === 'UNAUTHORIZED') return <Navigate to={'/'} replace={true} />;

    if (data.code === '200') {
      // fillData();
      const { countPerPage, currentPage, totalCount } = data.result.condition;
      const startNo = totalCount - (currentPage - 1) * countPerPage;

      data.result.results.forEach((item: ProductUser, index: number) =>
        productUsers.push({
          no: startNo - index,
          companyId: item.companyId,
          companyName: he.decode(item.companyName),
          lastUpdate: item.lastUpdate,
          receivingCount: item.receivingCount,
          sendingCount: item.sendingCount,
        }),
      );
    }
  }

  const moveToDetailItemPage = (item: string, companyName: string) => {
    navigate(`/transfer/${item}`, { state: companyName });
  };

  return (
    <>
      <Body data-page-type={'table-only'}>
        <StyledFlexColumnsWrapper>
          <strong>Transfer</strong>

          <StyledSearchBarWrapper>
            <Filters
              searchConditions={valueState}
              setSearchConditions={setValueState}
              conditionType={{
                searchType: [
                  {
                    label: 'ID',
                    value: 'ID',
                  },
                  { label: 'Company', value: 'COMPANY' },
                ],
              }}
              hasRangeType={false}
              hasTransferCheck={true}
            />
          </StyledSearchBarWrapper>
          {data && data.result && (
            <>
              <Worklist
                headers={[
                  { label: 'No', data_label: 'no' },
                  { label: 'ID', data_label: 'companyId' },
                  { label: 'Company', data_label: 'companyName' },
                  { label: 'Sending', data_label: 'sendingCount' },
                  { label: 'Receiving', data_label: 'receivingCount' },
                  { label: 'Last Update', data_label: 'lastUpdate' },
                ]}
                data={{ dataArray: productUsers }}
                customColumn={{
                  sendingCount: (row) => (
                    <u
                      onClick={() => {
                        moveToDetailItemPage(`sending/${row.companyId}`, row.companyName);
                      }}
                    >
                      {row.sendingCount}
                    </u>
                  ),
                  receivingCount: (row) => (
                    <u
                      onClick={() => {
                        moveToDetailItemPage(`receiving/${row.companyId}`, row.companyName);
                      }}
                    >
                      {row.receivingCount}
                    </u>
                  ),
                }}
              />
              {data && data.result && data.result?.condition.totalCount > 0 && (
                <Pagination conditions={data.result.condition} setConditions={setPageConditionsValue} />
              )}
            </>
          )}
        </StyledFlexColumnsWrapper>
      </Body>
    </>
  );
};

export default Transfer;
